import script from "./showOtherIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./showOtherIndex.vue?vue&type=script&setup=true&lang=js"

import "./showOtherIndex.vue?vue&type=style&index=0&id=c9225bc4&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9225bc4"]])

export default __exports__